module.exports = function(cb) {
	require.ensure([], function(require) {
		cb(require("!!../../../../node_modules/happypack/loader.js?id=jsx!./ConfigResourceView.jsx"));
	}, "ConfigResource");
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/bundle-loader?lazy&name=ConfigResource!./src/pages/bundle-appResource-mgmt/ConfigResource/ConfigResourceView.jsx
// module id = ./node_modules/bundle-loader/index.js?lazy&name=ConfigResource!./src/pages/bundle-appResource-mgmt/ConfigResource/ConfigResourceView.jsx
// module chunks = 43